import React from 'react';
export function Footer() {
  return <footer className="bg-black py-8 border-t border-dark-border text-center px-4" data-id="element-124">
      <div className="max-w-4xl mx-auto" data-id="element-125">
        <p className="text-gold-dark text-sm" data-id="element-126">
          © {new Date().getFullYear()} Dance Technique Teacher Ready™ — All
          Rights Reserved.
        </p>
      </div>
    </footer>;
}